module.exports = __webpack_public_path__ + "static/img/nanjing.c6c5293.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/nanjing.jpg
// module id = Cadq
// module chunks = 1